import React, { useState, useEffect } from 'react';
import { Card, SectionHeader, StatCard, NeedProject, RNLLoader } from '../components/UI';
import { useParams, useNavigate } from 'react-router-dom';
import * as api from '../api';

export default function SiteLabourDashboardPage({ toast }) {
  const { projectId } = useParams();
  const navigate = useNavigate();
  const [stats, setStats] = useState({
    labourCount: 0,
    siteIssuesCount: 0,
    issuesOpen: 0
  });

  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!projectId) return;
    const load = async () => {
      setLoading(true);
      try {
        const [lab, issue] = await Promise.all([
          api.listLabourEntries(projectId).catch(() => []),
          api.listSiteIssues(projectId).catch(() => []),
        ]);
        setStats({
          labourCount: lab.length,
          siteIssuesCount: issue.length,
          issuesOpen: issue.filter(i => i.status === 'open').length
        });
      } catch (e) {}
      setLoading(false);
    };
    load();
  }, [projectId]);

  if (!projectId) return <NeedProject />;

  return (
    <div className="fade-in">
      <SectionHeader title="Site & Labour Management" subtitle="Overview" />
      
      {loading ? (
        <RNLLoader title="Loading Dashboard..." subtitle="Please wait" />
      ) : (
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: 12, marginBottom: 24 }}>
          <StatCard label="Labour Entries" value={stats.labourCount} color="cyan" icon="⏱️" />
          <StatCard label="Total Site Issues" value={stats.siteIssuesCount} color="amber" icon="⚡" />
          <StatCard label="Open Issues" value={stats.issuesOpen} color="red" icon="⚠" />
        </div>
      )}

      {/* DIVIDER */}
      <hr style={{ border: 'none', borderTop: '3px solid #94a3b8', margin: '0 0 32px 0' }} />

      <div style={{ display: 'flex', gap: 16, flexWrap: 'wrap' }}>
        <Card
          className="toggle-on-hover"
          onClick={() => navigate(`/projects/${projectId}/labour/entries`)}
          style={{ width: 280, padding: 24, cursor: 'pointer', textAlign: 'center', display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 12, border: '1px solid black' }}
          onMouseEnter={e => e.currentTarget.style.borderColor = 'var(--accent)'}
          onMouseLeave={e => e.currentTarget.style.borderColor = 'black'}
        >
          <span style={{ fontSize: 32, padding: 12, background: 'var(--accent-dim)', borderRadius: 16 }}>⏱️</span>
          <span style={{ fontWeight: 700, fontSize: 16 }}>Labour & Timesheets</span>
          <span style={{ fontSize: 12, color: 'var(--text-muted)' }}>Manage daily timesheets and track labour budgets.</span>
        </Card>

        <Card
          className="toggle-on-hover"
          onClick={() => navigate(`/projects/${projectId}/site/issues`)}
          style={{ width: 280, padding: 24, cursor: 'pointer', textAlign: 'center', display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 12, border: '1px solid black' }}
          onMouseEnter={e => e.currentTarget.style.borderColor = 'var(--accent)'}
          onMouseLeave={e => e.currentTarget.style.borderColor = 'black'}
        >
          <span style={{ fontSize: 32, padding: 12, background: 'var(--accent-dim)', borderRadius: 16 }}>⚡</span>
          <span style={{ fontWeight: 700, fontSize: 16 }}>Site Execution</span>
          <span style={{ fontSize: 12, color: 'var(--text-muted)' }}>Track site issues and material transactions.</span>
        </Card>
      </div>
    </div>
  );
}
